import React, {Fragment, useContext, useState, useEffect} from 'react'
import {moneyFormatter} from '../../../../../../utils'
import {QuickOrderContext} from '../../../../../context/QuickOrderContext'
import { getUniqueIdWithPrefix } from '../../../../../../_metronic/assets/ts/_utils'
import { 
  ORDER_TAB_RAINWATER_MITRE_INTERNAL,
  ORDER_TAB_RAINWATER_MITRE_EXTERNAL,
  ORDER_TAB_RAINWATER_CHECKBOX_TOOLTIP_WITH_NO_PRICE
} from '../../../../../common/constant'

function NewMitreItem(props: any) {
  const {setIsMitreInternalChecked} = props

  const {addToCart, colours, cartItems, mitreInternalId, mitreExternalId} = useContext(QuickOrderContext)

  useEffect(() => {
    loadMitreInternalColourOption()
    loadMitreExternalColourOption()
  }, [])  

  const [colourOptionMitreInternal, setColourOptionMitreInternal] = useState<any[]>([])
  const [colourOptionMitreExternal, setColourOptionMitreExternal] = useState<any[]>([])

  const loadMitreInternalColourOption = () => {
    const availableColour = props.mitreInternalItems.filter((item: any) => 
        item.rainwaterPartId == mitreInternalId
    )

    const colourSelection: any = Object.values(
        availableColour.reduce((map: any, obj: any) => {
            const key = `${obj.rainwaterColourId}-${obj.rainwaterColourName}`
            if (!map[key]) {
            map[key] = obj
            }
            return map
        }, {} as Record<string, any>)
    )

    const result = (colourSelection || [])?.map((availPricing: any) => ({
        id: availPricing.rainwaterColourId,
        name: availPricing.rainwaterColourName,
    }))

    // default selection for colour
    const existsDataColour = result.filter((item1: any) =>
        cartItems.some(
            (x: any) =>
                x.type === 'panel' &&
                x.topSheetColourName.toLowerCase().includes(item1.name.toLowerCase())
        )
    )
    if (existsDataColour) {
        if (existsDataColour && existsDataColour.length === 1) {
            const defaultColour = existsDataColour[0]
            props.setMitreInternalColourId(defaultColour.id)
            props.setMitreInternalColor(defaultColour.id)
            props.setMitreInternalColorName(defaultColour.name)
        } else {
            props.setMitreInternalColor(0)
            props.setMitreInternalColourId(0)
        }
    } else {
        props.setMitreInternalColor(0)
        props.setMitreInternalColourId(0)
    }

    setColourOptionMitreInternal(result)
  }

  const loadMitreExternalColourOption = () => {
    const availableColour = props.mitreExternalItems.filter((item: any) => 
        item.rainwaterPartId == mitreExternalId
    )

    const colourSelection: any = Object.values(
        availableColour.reduce((map: any, obj: any) => {
            const key = `${obj.rainwaterColourId}-${obj.rainwaterColourName}`
            if (!map[key]) {
            map[key] = obj
            }
            return map
        }, {} as Record<string, any>)
    )

    const result = (colourSelection || [])?.map((availPricing: any) => ({
        id: availPricing.rainwaterColourId,
        name: availPricing.rainwaterColourName,
    }))

    // default selection for colour
    const existsDataColour = result.filter((item1: any) =>
        cartItems.some(
            (x: any) =>
                x.type === 'panel' &&
                x.topSheetColourName.toLowerCase().includes(item1.name.toLowerCase())
        )
    )
    if (existsDataColour) {
        if (existsDataColour && existsDataColour.length === 1) {
            const defaultColour = existsDataColour[0]
            props.setMitreExternalColourId(defaultColour.id)
            props.setMitreExternalColor(defaultColour.id)
            props.setMitreExternalColorName(defaultColour.name)
        } else {
            props.setMitreExternalColor(0)
            props.setMitreExternalColourId(0)
        }
    } else {
        props.setMitreExternalColor(0)
        props.setMitreExternalColourId(0)
    }

    setColourOptionMitreExternal(result)
  }

  useEffect(() => {
    if (Object.keys(props.selectedGutterItemForMitreInternal || {}).length !== 0) {
      props.setMitreInternalPrice(
        props.mitreInternalPricings.find(
          (item: any) =>
            item?.rainwaterPartName === ORDER_TAB_RAINWATER_MITRE_INTERNAL &&
            item?.rainwaterStyleId === +props.selectedGutterItemForMitreInternal?.rainwaterStyleId &&
            item?.rainwaterColourId === props.mitreInternalColor
        )
      )
    } else {
      props.setMitreInternalPrice(0)
    }
  }, [props.selectedGutterItemForMitreInternal, props.mitreInternalColor])

  useEffect(() => {
    if (Object.keys(props.selectedGutterItemForMitreExternal || {}).length !== 0) {
      props.setMitreExternalPrice(
        props.mitreExternalPricings.find(
          (item: any) =>
            item?.rainwaterPartName === ORDER_TAB_RAINWATER_MITRE_EXTERNAL &&
            item?.rainwaterStyleId === +props.selectedGutterItemForMitreExternal?.rainwaterStyleId &&
            item?.rainwaterColourId === props.mitreExternalColor
        )
      )
    } else {
      props.setMitreExternalPrice(0)
    }
  }, [props.selectedGutterItemForMitreExternal, props.mitreExternalColor])

  const handleMitreInternalCheckboxChange = (event: any) => {
    if (event.target.checked) {
      props.setIsMitreInternalChecked(true)
    } else {
      props.setIsMitreInternalChecked(false)
    }
  }

  const handleMitreExternalCheckboxChange = (event: any) => {
    if (event.target.checked) {
      props.setIsMitreExternalChecked(true)
    } else {
      props.setIsMitreExternalChecked(false)
    }
  }

  const handleMitreInternalQuantityChange = (e: any) => {
    const inputNumber = parseInt(e.target.value, 10)
    if (inputNumber === 0 || inputNumber < 0) {
      return
    }
    props.setMitreInternalQuantity(inputNumber)
  }

  const handleMitreExternalQuantityChange = (e: any) => {
    const inputNumber = parseInt(e.target.value, 10)
    if (inputNumber === 0 || inputNumber < 0) {
      return
    }
    props.setMitreExternalQuantity(inputNumber)
  }

  const handleMitreInternalColorOnChange = (e: any) => {
    const selectedIndex = e.target.options.selectedIndex
    const name = selectedIndex == 0 ? '' : colourOptionMitreInternal[selectedIndex - 1].name
    props.setMitreInternalColourId(+e.target.value)
    props.setMitreInternalColor(+e.target.value)
    props.setMitreInternalColorName(name)
  }

  const handleMitreExternalColorOnChange = (e: any) => {
    const selectedIndex = e.target.options.selectedIndex
    const name = selectedIndex == 0 ? '' : colourOptionMitreExternal[selectedIndex - 1].name
    props.setMitreExternalColourId(+e.target.value)
    props.setMitreExternalColor(+e.target.value)
    props.setMitreExternalColorName(name)
  }

  const disabledMitreInternal =
    !props.isMitreInternalChecked ||
    props.mitreInternalQuantity === '' ||
    isNaN(props.mitreInternalQuantity)

  const disabledMitreExternal =
    !props.isMitreExternalChecked ||
    props.mitreExternalQuantity === '' ||
    isNaN(props.mitreExternalQuantity)    
  
  return (
    <Fragment>
      <div className='row  mb-4'>
        <div className='col-md-3  d-flex align-items-center justify-content-between'>
          <div
            title={
              !props.mitreInternalPrice?.priceLevel1
                ? ORDER_TAB_RAINWATER_CHECKBOX_TOOLTIP_WITH_NO_PRICE
                : ""
            }
          >
            <input
              className='form-check-input'
              type='checkbox'
              id='mitreInternal'
              name='mitreInternal'
              onChange={handleMitreInternalCheckboxChange}
              checked={props.isMitreInternalChecked}
              style={{marginRight: 10}}
              disabled={
                Object.keys(props.selectedGutterItemForMitreInternal || {}).length === 0 ||
                props.selectedGutterItemForMitreInternal === undefined ||
                !props.mitreInternalPrice?.priceLevel1
              }
            />
            <label className='fw-bolder text-dark'>Mitre Internal</label>
          </div>
          <span style={{fontSize: 16, fontWeight: 'bold'}}>
            {moneyFormatter.format(
              props.mitreInternalPrice?.priceLevel1 !== undefined &&
                props.mitreInternalPrice &&
                props.selectedGutterItemForMitreInternal !== undefined
                ? props.mitreInternalPrice?.priceLevel1
                : 0
            )}
          </span>
        </div>
        {/* Quantity */}
        <div className='col-md-3'>
          <label className='fw-bolder text-dark'>Quantity</label>
          <input
            style={{fontSize: '1rem'}}
            type='number'
            min='1'
            step='1'
            className='form-control'
            id='mitreInternalQuantity'
            aria-describedby='mitreInternalQuantity'
            value={props.mitreInternalQuantity || ''}
            onChange={handleMitreInternalQuantityChange}
            placeholder='Enter Quantity'
            disabled={
              !props.isMitreInternalChecked
            }
          />
        </div>
        {/* Colour */}
        <div className='col-md-3'>
          <label className='fw-bolder text-dark'>Colour</label>
          <select
              style={{ fontSize: '1rem' }}
              className='form-select'
              value={props.mitreInternalColor}
              onChange={handleMitreInternalColorOnChange}
              disabled={!props.isMitreInternalChecked}
          >
              <option value={0}>Select</option>
              {colourOptionMitreInternal?.map((option: any, index: number) => (
                  <option key={index} value={option.id}>
                      {option.name}
                  </option>
              ))}
          </select>
        </div>
        <div className='col-md-3'>
        </div>
      </div>
      <div className='row  mb-4'>
        <div className='col-md-3  d-flex align-items-center justify-content-between'>
          <div
            title={
              !props.mitreExternalPrice?.priceLevel1
                ? ORDER_TAB_RAINWATER_CHECKBOX_TOOLTIP_WITH_NO_PRICE
                : ""
            }
          >
            <input
              className='form-check-input'
              type='checkbox'
              id='mitreExternal'
              name='mitreExternal'
              onChange={handleMitreExternalCheckboxChange}
              checked={props.isMitreExternalChecked}
              style={{marginRight: 10}}
              disabled={
                Object.keys(props.selectedGutterItemForMitreExternal || {}).length === 0 ||
                props.selectedGutterItemForMitreExternal === undefined ||
                !props.mitreExternalPrice?.priceLevel1
              }
            />
            <label className='fw-bolder text-dark'>Mitre External</label>
          </div>
          <span style={{fontSize: 16, fontWeight: 'bold'}}>
            {moneyFormatter.format(
              props.mitreExternalPrice?.priceLevel1 !== undefined &&
                props.mitreExternalPrice &&
                props.selectedGutterItemForMitreExternal !== undefined
                ? props.mitreExternalPrice?.priceLevel1
                : 0
            )}
          </span>
        </div>
        {/* Quantity */}
        <div className='col-md-3'>
          <label className='fw-bolder text-dark'>Quantity</label>
          <input
            style={{fontSize: '1rem'}}
            type='number'
            min='1'
            step='1'
            className='form-control'
            id='mitreExternalQuantity'
            aria-describedby='mitreExternalQuantity'
            value={props.mitreExternalQuantity || ''}
            onChange={handleMitreExternalQuantityChange}
            placeholder='Enter Quantity'
            disabled={
              !props.isMitreExternalChecked
            }
          />
        </div>
        {/* Colour */}
        <div className='col-md-3'>
          <label className='fw-bolder text-dark'>Colour</label>
          <select
              style={{ fontSize: '1rem' }}
              className='form-select'
              value={props.mitreExternalColor}
              onChange={handleMitreExternalColorOnChange}
              disabled={!props.isMitreExternalChecked}
          >
              <option value={0}>Select</option>
              {colourOptionMitreExternal?.map((option: any, index: number) => (
                  <option key={index} value={option.id}>
                      {option.name}
                  </option>
              ))}
          </select>
        </div>
        <div className='col-md-3'>
        </div>
      </div>
    </Fragment>
  )
}

export default NewMitreItem